import React from 'react';
import { Select, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { localeOptions } from 'app/molecules/LanguagePicker';
import { fieldDefaultProps } from 'utils/fieldConfig';

function LanguagePreferrence() {
  const { t } = useTranslation();

  return (
    <Form.Item
      label={t('auth.signup.languagePreference.fields.select')}
      name="preferredLanguage"
      initialValue={localeOptions[0].key} // english as a an default value
      rules={[{ required: true, message: t('auth.signup.languagePreference.required') }]}
    >
      <Select
        {...fieldDefaultProps}
        placeholder={t('auth.signup.languagePreference.placeholder')}
        data-testid="language-select"
      >
        {localeOptions.map((option) => (
          <Select.Option key={option.key} value={option.key}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
}

export default LanguagePreferrence;
